/**
 * PortalProtectedRoute.js
 * Route guard for athlete portal routes - requires authentication only
 */

import { useEffect } from 'react';
import { authService } from '../../services/api';

const PortalProtectedRoute = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();

  useEffect(() => {
    if (!isAuthenticated) {
      window.location.href = '/login';
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return null;
  }

  return children;
};

export default PortalProtectedRoute;
